import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { CourseGraphCanvas } from "./CourseGraphCanvas";
import type { CourseNodeWithStatus } from "@/types/courses";

interface CourseGraphDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  nodes: CourseNodeWithStatus[];
}

export const CourseGraphDialog: React.FC<CourseGraphDialogProps> = ({
  open,
  onOpenChange,
  nodes,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-6xl h-[85vh] flex flex-col p-0 gap-0 max-sm:h-[100dvh] max-sm:max-w-full max-sm:rounded-none max-sm:border-0">
        <DialogHeader className="px-6 pt-5 pb-3 border-b border-border shrink-0">
          <DialogTitle>Course Graph</DialogTitle>
        </DialogHeader>

        <div className="flex-1 relative overflow-hidden">
          {/* Legend */}
          <div className="absolute top-4 left-4 z-10 bg-background/90 backdrop-blur-sm border border-border rounded-xl px-4 py-3 space-y-1.5 text-sm">
            <div className="flex items-center gap-2">
              <span className="h-3 w-3 rounded-full bg-correct" />
              <span className="text-foreground">Complete</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="h-3 w-3 rounded-full bg-primary" />
              <span className="text-foreground">In Progress</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="h-3 w-3 rounded-full border-2 border-border bg-background" />
              <span className="text-foreground">Not Started</span>
            </div>
            <div className="border-t border-border pt-1.5 mt-1.5 space-y-0.5 text-xs text-muted-foreground">
              <p>• Click any lesson to see how it relates</p>
              <p className="hidden sm:block">• Scroll to zoom</p>
              <p className="hidden sm:block">• Click + drag to pan</p>
            </div>
          </div>

          <CourseGraphCanvas nodes={nodes} />
        </div>
      </DialogContent>
    </Dialog>
  );
};
